module.exports = __webpack_public_path__ + "img/about_brand_bk.bb3f6a76.png";